import { formatCurrency, PrecisionOptions } from '@utils'
import cn from 'classnames'
import React from 'react'
import styled from 'styled-components'

interface Props {
  value: number
  precision?: PrecisionOptions
  showColor?: boolean
  currency?: string
}

export const MonetaryAmount: React.FC<Props> = ({
  value,
  currency,
  precision,
  showColor = false
}) => {
  const isPositive = value > 0 && showColor
  const isNegative = value < 0 && showColor
  const isNeutral = value === 0 && showColor

  return (
    <StyledMonetaryAmount className={cn({ isPositive, isNegative, isNeutral })}>
      {formatCurrency(value, precision, currency)}
    </StyledMonetaryAmount>
  )
}

const StyledMonetaryAmount = styled.span`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  &.isPositive {
    color: ${({ theme }) => theme.colors.success};
  }

  &.isNegative {
    color: ${({ theme }) => theme.colors.dashboardNeg};
  }

  &.isNeutral {
    color: ${({ theme }) => theme.colors.metalGray};
  }
`
